// // // //
// Small client-side formatting helpers.
//
// The tRPC client in this app has no data transformer configured, so `Date`
// fields arrive over the wire as ISO strings at runtime even though the
// inferred types say `Date`. These helpers accept either and normalize.

export function toDateString(
    value: Date | string | null | undefined,
): string | undefined {
    if (!value) return undefined;
    return value instanceof Date ? value.toISOString() : value;
}

/** Format a date as e.g. "Jan 9, 2026" for compact meta lines. */
export function formatShortDate(value: Date | string): string {
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleString("en-us", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "utc",
    });
}

/** Truncate a client id for display, keeping the recognizable prefix. */
export function truncateClientId(clientId: string): string {
    if (clientId.length <= 20) return clientId;
    return `${clientId.slice(0, 16)}…`;
}
